/* legacy-smart-answer-card-without-streaming-expand.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./legacy-smart-answer-card-without-streaming-expand.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Fragment, useCallback, useEffect, useState } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { AISources, useAnalytics } from '../../common';
import { SainAction, useSAINUsageCriteriaMet } from '../../common/controller/analytics';
import { AIAnswerBody } from '../ai-answer-body';
import { useAIAnswerContext } from '../ai-answer-context';
import { AIAnswerFooter } from '../ai-answer-footer';
import { AIAnswerLoadingDialog } from '../ai-answer-loading/ai-answer-loading-dialog';
import { aiAnswerCollapseClicked, aiAnswerExpandClicked, aiAnswerExpandShown, onAIAnswerSourceClick } from '../analytics';
import { NLPSearchResultFormat } from '../types';
import { Collapse } from './collapse';
import { AIAnswerSearchBorder } from './styled';
var styles = {
  spacer: "_4t3idlk8 _ca0qv47k",
  errorContainer: "_19pku2gc _otyrpxbi",
  sourcesContainer: "_ca0qidpf _u5f31ejb _n3tdu2gc _19bv1ejb"
};
var MAX_SOURCES = 4;
// TODO remove this file when cleaning up `kd_sain_enable_expand_when_streaming`
/**
 * @deprecated This component is the old LegacySmartAnswerCard that didn't support expansion while streaming
 * use LegacySmartAnswerCard instead
 */
export var LegacySmartAnswerCardWithoutStreamingExpand = function LegacySmartAnswerCardWithoutStreamingExpand(_ref) {
  var LoadingWrapper = _ref.LoadingWrapper,
    DialogWrapper = _ref.DialogWrapper,
    onFMPReached = _ref.onFMPReached,
    onAnswerExpandedChange = _ref.onAnswerExpandedChange;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    callbacks = _useAIAnswerContext.callbacks,
    loading = _useAIAnswerContext.loading,
    isReadingAids = _useAIAnswerContext.isReadingAids,
    onClose = _useAIAnswerContext.onClose,
    hasError = _useAIAnswerContext.hasError,
    initiallyExpanded = _useAIAnswerContext.initiallyExpanded;
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var answerFormat = commonAttributes.answerFormat,
    query = commonAttributes.query;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var isQuickSearch = Boolean(!isReadingAids && onClose);

  // reset on each new query
  useEffect(function () {
    setCollapsed(!initiallyExpanded);
    // Notify parent context of initial state
    onAnswerExpandedChange === null || onAnswerExpandedChange === void 0 || onAnswerExpandedChange(!initiallyExpanded);
  }, [query, initiallyExpanded, onAnswerExpandedChange]);

  // Call onFMPReached when answer is loaded
  useEffect(function () {
    if (!loading && !hasError) {
      onFMPReached === null || onFMPReached === void 0 || onFMPReached();
    }
  }, [loading, hasError, onFMPReached]);
  var toggleCollapsedState = function toggleCollapsedState() {
    if (collapsed) {
      fireSAINUsageEvent({
        metCriteria: SainAction.EXPAND_CLICKED,
        commonAttributes: commonAttributes
      });
    }
    setCollapsed(!collapsed);
    // Notify parent context of state change
    onAnswerExpandedChange === null || onAnswerExpandedChange === void 0 || onAnswerExpandedChange(!collapsed);
  };
  var analyticsCallbacks = {
    onExpandedByDefault: function onExpandedByDefault() {
      return fireAnalyticsEvent(aiAnswerExpandShown(commonAttributes));
    },
    onExpandClicked: function onExpandClicked() {
      return fireAnalyticsEvent(aiAnswerExpandClicked(commonAttributes));
    },
    onCollapseClicked: function onCollapseClicked() {
      return fireAnalyticsEvent(aiAnswerCollapseClicked(commonAttributes));
    }
  };
  var sourceClickCallback = useCallback(function (index, source, hostname) {
    var _callbacks$onAIAnswer;
    fireAnalyticsEvent(onAIAnswerSourceClick(_objectSpread({
      sourceIndex: index,
      hostname: hostname,
      sourceProduct: source.product || ''
    }, commonAttributes)));
    fireSAINUsageEvent({
      metCriteria: SainAction.SOURCE_CLICKED,
      commonAttributes: commonAttributes,
      sourceProduct: source.product || ''
    });
    callbacks === null || callbacks === void 0 || (_callbacks$onAIAnswer = callbacks.onAIAnswerSourceClick) === null || _callbacks$onAIAnswer === void 0 || _callbacks$onAIAnswer.call(callbacks);
  }, [fireAnalyticsEvent, commonAttributes, fireSAINUsageEvent, callbacks]);
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingWrapper, null, /*#__PURE__*/React.createElement(AIAnswerLoadingDialog, null));
  }
  var aiAnswerContent = /*#__PURE__*/React.createElement(Collapse, {
    collapsed: collapsed,
    toggleCollapsedState: toggleCollapsedState,
    expandWhenClickedAnywhere: true,
    isLoading: false,
    callbacks: analyticsCallbacks
  }, /*#__PURE__*/React.createElement(AIAnswerBody, null));
  if (hasError) {
    aiAnswerContent = /*#__PURE__*/React.createElement(Box, {
      xcss: styles.errorContainer
    }, /*#__PURE__*/React.createElement(AIAnswerBody, null));
  } else if (isQuickSearch || answerFormat === NLPSearchResultFormat.JSON) {
    aiAnswerContent = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Box, {
      xcss: styles.spacer
    }), /*#__PURE__*/React.createElement(AIAnswerBody, null));
  }
  return /*#__PURE__*/React.createElement(DialogWrapper, null, /*#__PURE__*/React.createElement(AIAnswerSearchBorder, {
    isLoading: false,
    isStreaming: false
  }, aiAnswerContent, !hasError && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.sourcesContainer
  }, /*#__PURE__*/React.createElement(AISources, {
    sources: commonAttributes.sources,
    searchSessionId: commonAttributes.searchSessionId,
    onClickHandler: sourceClickCallback,
    limit: MAX_SOURCES,
    enableSmartLinkSources: true
  })), /*#__PURE__*/React.createElement(AIAnswerFooter, null)));
};